export default "__VITE_ASSET__12e5738a__"